var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { find } from "lodash";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { H3 } from "@irati/ui/src/Headings";
import Card from "@irati/ui/src/Layout/Card";
import { Para } from "@irati/ui/src/Labels";
import { minWidthMedia } from "@irati/ui/src/global/media";
import padding from "@irati/ui/src/global/padding";
import ShowPopUp from "@irati/store/actions/ShowSuccessPopUp";
import OnboardingSteps from "@irati/onboarding/enums/Step";
import onboardingService from "@irati/onboarding/services/onboarding";
import AuthActions from "@irati/auth/store/actions/AuthActions";
var BannerCTACard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", " auto;\n  ", "\n"], ["\n  margin: ", " auto;\n  ",
    "\n"])), padding.base, minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 360px;\n    margin: 0\n  "], ["\n    max-width: 360px;\n    margin: 0\n  "]))));
var BannerCTAHeading = styled(H3)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0 auto;\n  ", "\n"], ["\n  margin: 0 auto;\n  ",
    "\n"])), minWidthMedia.desktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 200px;\n  "], ["\n    max-width: 200px;\n  "]))));
var BannerCTAPara = styled(Para)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.base);
var Relative = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var TooltipAttach = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: -15px;\n"], ["\n  position: absolute;\n  top: -15px;\n"])));
var GETSTARTED = "getStarted";
var CTA = /** @class */ (function (_super) {
    __extends(CTA, _super);
    function CTA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popupTimeout = null;
        _this.completeStep = function (step) {
            var auth = _this.props.auth;
            onboardingService.completeStep(auth.user, step, auth.accessToken).then(function (onboarding) {
                _this.props.updateAuth(auth.user, onboarding);
            });
        };
        return _this;
    }
    CTA.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, isMobile = _a.isMobile, showPopUp = _a.showPopUp, onboarding = _a.auth.onboarding;
        window.scrollTo(0, 0);
        var hasViewedMedicalGetStartedPage = find(onboarding.completedSteps, function (step) {
            return step === OnboardingSteps.HAS_VIEWED_MEDICAL_GET_STARTED_PAGE;
        });
        var hasHiddenMedicalGetStartedTooltip = find(onboarding.completedSteps, function (step) {
            return step === OnboardingSteps.HAS_HIDDEN_MEDICAL_GET_STARTED_PAGE;
        });
        if (!isMobile) {
            if (hasViewedMedicalGetStartedPage && !hasHiddenMedicalGetStartedTooltip) {
                var formatMessage = this.props.formatMessage;
                var tooltip = {
                    show: true,
                    text: formatMessage({ id: "medical.landing.tooltip.text" }),
                    subtext: formatMessage({ id: "medical.tooltip.subtext" }),
                    anchor: GETSTARTED,
                    positionVertically: true,
                    height: 200,
                    onChange: function () { return _this.completeStep(OnboardingSteps.HAS_HIDDEN_MEDICAL_GET_STARTED_PAGE); }
                };
                showPopUp(tooltip);
                this.popupTimeout = setTimeout(function () {
                    showPopUp({ show: false });
                }, 10000);
            }
            else {
                this.completeStep(OnboardingSteps.HAS_VIEWED_MEDICAL_GET_STARTED_PAGE);
            }
        }
    };
    CTA.prototype.componentWillUnmount = function () {
        if (this.popupTimeout) {
            clearTimeout(this.popupTimeout);
        }
        this.props.showPopUp({ show: false });
    };
    CTA.prototype.componentDidUpdate = function () {
        var _a = this.props, isMobile = _a.isMobile, showPopUp = _a.showPopUp;
        if (isMobile) {
            showPopUp({ show: false });
        }
    };
    CTA.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, attachGetStartedTooltip = _a.attachGetStartedTooltip;
        return (React.createElement(BannerCTACard, null,
            React.createElement(BannerCTAHeading, { base: true },
                React.createElement(FormattedMessage, { id: "medical.landing.CTA.heading.firstWord" }),
                React.createElement("strong", null,
                    React.createElement(FormattedMessage, { id: "medical.landing.CTA.heading.bold" })),
                React.createElement(FormattedMessage, { id: "medical.landing.CTA.heading.sentenceEnd" })),
            React.createElement(BannerCTAPara, { light: true, narrow: true },
                React.createElement(FormattedMessage, { id: "medical.landing.CTA.para" })),
            React.createElement(Button, { full: true, large: true, primary: true, onClick: onClick },
                React.createElement(FormattedMessage, { id: "medical.landing.CTA.button" })),
            React.createElement(Relative, null, attachGetStartedTooltip && React.createElement(TooltipAttach, { "data-attach-tooltip": "getStarted" }))));
    };
    return CTA;
}(PureComponent));
var mapStateToProps = function (state) {
    return {
        isMobile: state.mq.lessThan.large,
        auth: state.auth
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    showPopUp: function (options) { return dispatch(ShowPopUp(options)); },
    updateAuth: function (user, onboarding) { return dispatch(AuthActions.UpdateAuthAction({ user: user, onboarding: onboarding })); }
}); };
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CTA));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
